<template>
  <div class="safe_setting">
    <div class="setting_item" @click="openPage('/password')">
      <div class="item_label">修改账号密码</div>
      <van-icon name="arrow" class="edit_icon" />
    </div>
    <div class="setting_item" @click="openPage('/vertify')">
      <div class="item_label">实名认证</div>
      <van-icon v-if="!accountInfo.hasCertify" name="arrow" class="edit_icon" />
      <span v-else style="color: green">已认证</span>
    </div>
    <div class="setting_item" @click="openPage('/mobile')">
      <div class="item_label">绑定手机号</div>
      <van-icon name="arrow" class="edit_icon" />
    </div>
    <div class="setting_item mt" @click="openPage('/alipayAccount')">
      <div class="item_label">提现支付宝账号</div>
      <van-icon name="arrow" class="edit_icon" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      accountInfo: this.account(),
    };
  },
  mounted() {},
  methods: {
    ...mapGetters(["account"]),
    openPage(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.safe_setting {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-top: 3.2vw;
  .setting_item {
    padding: 4.267vw;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item_label {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.85);
    }
    .edit_icon {
      color: #aaacb1;
    }
  }
  .mt {
    margin-top: 3.2vw;
  }
}
</style>
